// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — date-select.classic.js, новая — date-select.cp.js
import { isCp } from 'libs/design';
import * as classic from './date-select.classic';
import * as cp from './date-select.cp';

export const DateSelect = isCp ? cp.DateSelect : classic.DateSelect;
